<template>
  <div class="about-socialResponsibility">
    <div class="about-socialResponsibility-title">社会责任</div>
    <div class="about-socialResponsibility-content">
      <TimeAxios
        v-for="(item, index) in data"
        :key="`timeAxis-item${index + 1}`"
        :data="item"
      />
    </div>
  </div>
</template>
<script>
import TimeAxios from "@/components/timeAxis.vue";
export default {
  name: "about-socialResponsibility",
  components: { TimeAxios },
  data() {
    return {
      data: [
        {
          time: "2026-5",
          title: "爱心公益活动《跨越山海，点亮希望》",
          desc:
            "华院计算在六一前夕，为新疆莎车县希望小学在内的共三所学校，捐书籍与文具物资，书籍500多本，学习文具及作业本7500多件，为孩子们追逐梦想筑牢根基。"
        },
        {
          time: "2025-10",
          title: "华院计算被认定为“上海市就业见习基地”",
          desc:
            "华院计算履行缓解青年就业结构性矛盾与推动产教融合人才培养的社会责任。该基地的设立是华院计算将企业发展融入社会民生需求的直接体现，通过制度化的人才孵化机制，实现企业成长与社会就业稳定的双赢。"
        },
        {
          time: "2024-12",
          title: "华院计算向江西理工大学教育基金会捐赠",
          desc:
            "为弘扬中华民族美德，促进江西理工大学教育事业发展，华院计算向江西理工大学教育基金会进行了捐赠，设立人才培养基金，鼓励江西理工的在校大学生不断追求卓越，实现自我价值。"
        },
        {
          time: "2023",
          title: "华院数智人“疫”线助农，云端助力乡村振兴",
          desc:
            "脐橙消费的黄金时期，因疫情原因使得原定脐橙直播销售工作进入停摆状态。华院计算应相关部门邀请提供数智人，通过虚拟主播方式“空降”脐橙直播间，帮助赣南脐橙远销至千家万户，保证了当地果农的销售需求。"
        },
        {
          time: "2022",
          title: "华院传递温暖共抗疫情",
          desc:
            "华院计算在得知一些员工所住的疫情重点防控地区缺乏生活物资，相关社区老人购菜困难的情况，于是火速调用资源，赠送了多种荤素菜给小区的老人家庭。",
          top: 10
        },
        {
          time: "2021-04",
          title: '为兴国县太平小学捐"爱心水井”',
          desc:
            "江西省赣州市兴国县崇贤乡太平小学和华院计算一起举办的公益“爱心水井”捐赠仪式顺利举行并设立快乐数学奖学金。",
          top: 10
        },
        {
          time: "2013-04",
          title: "为四川雅安地震募捐",
          desc:
            "华院计算为四川雅安地震发起内部募捐，将善款分别捐赠给“壹基金”和“免费午餐”，以帮助四川雅安的受灾群众。雅安加油！",
          top: 10
        },
        {
          time: "2011-12",
          title: "为新疆青河县阿合奇县受冻的孩子们捐款",
          desc:
            "华院计算为新疆青河县阿合奇县受冻的孩子们进行了一次捐款活动，合计筹款购买了大量当地急需的防寒物资。 通过克州移动和阿勒泰移动，我们的这批爱心物资捐献给克州团委和青河县查干郭勒乡牧业寄宿学校，提供给需要的孩子们。",
          top: 10
        },
        {
          time: "2010-06",
          title: "儿童节贫困地区物资捐赠",
          desc:
            "2010年6月，在儿童节到来之即，“华院阳光”在公司内部为贫困地区的小朋友组织了员工捐赠，内容包括学习用品、文体用品、日用品等，希望所有的小朋友都能有一个快乐的童年。",
          top: 10
        },
        {
          time: "2010-04",
          title: "“华院阳光”发起员工为玉树灾区捐款活动",
          desc: "2010年4月，“华院阳光”发起员工为玉树灾区捐款活动。",
          top: 20
        },
        {
          time: "2009-06",
          title: "“华院阳光”慈善基金正式成立",
          desc:
            "“华院阳光”慈善基金正式成立，致力于为更多贫困的孩子提供希望和帮助！",
          top: 10
        },
        {
          time: "2006-12",
          title: "捐助北京邮电大学研究生",
          desc:
            "2006年12月20日下午，北京邮电大学研究生资助基金座谈会在教一楼校学术委员会会议室召开",
          top: 5
        },
        {
          time: "2005-12",
          title: "北京邮电大学华院资助基金捐资暨颁发仪式隆重举行",
          desc:
            "春风化雨暖人心，润物无声泽后世。2005年12月28日，北京邮电大学华院资助基金捐资暨颁发仪式隆重举行",
          top: 10
        },
        {
          time: "2005-6",
          title: "华院计算及全体员工向安徽省石台县石台小学捐款并资助贫困学生",
          desc:
            "2005年6月，华院计算联动全体员工开展公益助学行动，向安徽省石台县石台小学捐赠爱心款项，精准资助校内家庭困难学生，以实际行动助力乡村教育发展。",
          top: 20
        },
        {
          time: "2005-01",
          title: "华院计算与新疆移动一起为希望工程捐款",
          desc: "2005年1月， 华院计算与新疆移动一起为希望工程捐款。",
          top: 20
        }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.about-socialResponsibility {
  padding: 44px 64px 96px 0px;
  background: #f8f9fb;
  .about-socialResponsibility-title {
    font-size: 40px;
    color: #08204d;
    line-height: 56px;
    text-align: center;
    margin-left: 64px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/about/socialResponsibility.vue